import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import SuccessCard from './SuccessCard';
import { Box, CircularProgress } from '@mui/material';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

// استایل‌ها
const SuccessBox = styled(Box)`
  background-color: #ffffff;
  width: 100%;
  height: auto;
  max-width: 400px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: auto;
  @media (max-width: 768px) {
    max-width: 350px;
  }
`;

const ApplicationStepFive: React.FC = () => {
  const navigate = useNavigate();
  const application = useSelector(
    (state: RootState) => state.unifiedForm.application,
  );

  console.log('ApplicationStepFive - Application Data:', {
    application_id: application.application_id,
    publisher_id: application.publisher_id,
    logo: application.logo,
    name_fa: application.fa_name,
    name_en: application.en_name,
    version_text: application.version_text,
  });

  if (!application.application_id) {
    return (
      <SuccessBox>
        <Box textAlign="center" py={4}>
          <CircularProgress />
        </Box>
      </SuccessBox>
    );
  }

  return (
    <SuccessBox>
      <SuccessCard
        imageUrl={application.logo || ''}
        title={'اپلیکیشن شما با موفقیت جهت بررسی ارسال شد'}
        // No sms is sent when an application is approved or rejected — see the
        // note in App\Domains\Application\Jobs\SendApplicationSubmitSms — so
        // this points at the panel rather than promising one.
        subtitle={'وضعیت بررسی را می‌توانید از پنل ناشران دنبال کنید'}
        buttonText={'فهمیدم، مشاهده اپلیکیشن‌ها'}
        // The applications list for the publisher this app belongs to, rather
        // than the identity list — the user just finished submitting an app.
        buttonNavigateTo={() =>
          navigate(
            application.publisher_id
              ? `/applications?publisherId=${application.publisher_id}`
              : '/identities',
          )
        }
        name_fa={application.fa_name || ''}
        name_en={application.en_name || ''}
        version={application.version_text || ''}
      />
    </SuccessBox>
  );
};

export default ApplicationStepFive;
